@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="trackerListingsSegments()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="trackerListingsSegments()"
        [valueColumnHeader]="'dashboard.visuals.widgets.trackerListings.tableLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    />
}
